import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { useHistory, useLocation } from 'react-router-dom';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import Reporting from '../Reporting/Reporting';
import Filing26Q from './Purchase/TDS_Payables_Reconciliation/form26QFiling';
import Filing24Q from './Purchase/TDS_Payables_Reconciliation/form24QFiling';
// import ReportingGSTR1A from '../Reporting_Gstr1a/reporting_gstr1a';
import Filing27Q from './Purchase/TDS_Payables_Reconciliation/27Q/form27qFiling';
export default function FilingCards() {
    const history = useHistory();
    const location = useLocation();

    const [sitemapData, setSitemapData] = useState(null);

    useEffect(() => {
        const storedSitemap = localStorage.getItem("sitemap");
        if (storedSitemap) {
            try {
                const parsed = JSON.parse(storedSitemap);
                setSitemapData(parsed);
            } catch (e) {
                console.error("Failed to parse sitemap from localStorage", e);
                setSitemapData(null);
            }
        }
    }, []);

    const salesAccess = sitemapData?.["ARC RECONCILLIATION"]?.SALES || [];
    const purchaseAccess = sitemapData?.["ARC RECONCILLIATION"]?.PURCHASE || [];

    const gstFilingOptions = [
        salesAccess.includes("FILLING") && {
            label: 'GSTR-1',
            path: '/Reporting',
            component: Reporting
        },
        // salesAccess.includes("FILLING") && {
        //     label: 'GSTR-1A',
        //     path: '/ReportingGTR1A',
        //     component: ReportingGSTR1A
        // },
    ].filter(Boolean);

    const tdsFilingOptions = [
        purchaseAccess.includes("26Q FILLING (Form-140)") && {
            label: '26Q FILING (Form-140)',
            path: '/26QFiling',
            component: Filing26Q
        },
        purchaseAccess.includes("24Q FILLING (Form-138)") && {
            label: '24Q FILING (Form-138)',
            path: '/24QFiling',
            component: Filing24Q
        },
         purchaseAccess.includes("27Q FILING (Form-144)") && {
            label: '27Q FILING (Form-144)',
            path: '/27QFiling',
            component: Filing27Q
        },
    ].filter(Boolean);

    const activeTab = [...gstFilingOptions, ...tdsFilingOptions].find(tab => tab.path === location.pathname);
    const ActiveComponent = activeTab?.component;

    const handleCardClick = (report) => {
        history.push(report.path);
    };

    return (
        <Box sx={{
            fontFamily: "'Inter', sans-serif",
            width: '100%',
            minHeight: '100vh',
            background: 'linear-gradient(to bottom, #e8eef5 0%, #f5f7fa 100%)',
            p: 0
        }}>
            {ActiveComponent ? (
                <ActiveComponent />
            ) : (
                <>
                    {/* Page Heading */}
                    <Box sx={{
                        textAlign: 'center',
                        pt: 3,
                        pb: 0.5
                    }}>
                        <Box sx={{
                            fontSize: '38px',
                            fontWeight: 900,
                            color: '#03406d',
                            letterSpacing: '2px',
                            fontFamily: '"Dosis", sans-serif',
                            textTransform: 'uppercase'
                        }}>
                            FILING
                        </Box>
                    </Box>
                    
                    {(gstFilingOptions.length > 0 && tdsFilingOptions.length > 0) ? (
                    <Box sx={{
                        display: 'flex',
                        gap: 3,
                        p: 4,
                        width: '100%'
                    }}>
                        {/* GST Module */}
                        <Box sx={{
                            flex: 1,
                            background: 'linear-gradient(to bottom, #e3f2fd 0%, #f0f4ff 100%)',
                            borderRadius: '16px',
                            overflow: 'hidden',
                            border: '3px solid #03406d',
                            boxShadow: '0 4px 20px rgba(3, 64, 109, 0.15)'
                        }}>
                            <Box sx={{
                                background: '#03406d',
                                p: 2,
                                mb: 2
                            }}>
                                <Box sx={{
                                    fontSize: '28px',
                                    fontWeight: 700,
                                    color: '#ffffff',
                                    textAlign: 'center',
                                    letterSpacing: '1px'
                                }}>
                                    GST MODULE
                                </Box>
                            </Box>
                            <Box sx={{ p: 4, pt: 0 }}>
                                <Box sx={{
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(2, 1fr)',
                                    gap: 2.5
                                }}>
                                    {gstFilingOptions.map((report, index) => (
                                        <Box
                                            key={index}
                                            onClick={() => handleCardClick(report)}
                                            sx={{
                                                background: '#ffffff',
                                                borderRadius: '12px',
                                                p: 3,
                                                cursor: 'pointer',
                                                transition: 'all 0.2s ease',
                                                boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                                                minHeight: '80px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                borderLeft: '5px solid #03406d',
                                                position: 'relative',
                                                overflow: 'hidden',
                                                '&::before': {
                                                    content: '""',
                                                    position: 'absolute',
                                                    left: 0,
                                                    top: 0,
                                                    height: '100%',
                                                    width: '5px',
                                                    background: '#03406d',
                                                    transition: 'width 0.4s ease',
                                                    zIndex: 0
                                                },
                                                '&:hover': {
                                                    transform: 'translateY(-4px)',
                                                    boxShadow: '0 4px 16px rgba(3, 64, 109, 0.25)',
                                                    '& > div': {
                                                        color: '#ffffff'
                                                    }
                                                },
                                                '&:hover::before': {
                                                    width: '100%'
                                                }
                                            }}
                                        >
                                            <Box sx={{
                                                fontSize: '16px',
                                                fontWeight: 600,
                                                color: '#212121',
                                                textAlign: 'center',
                                                position: 'relative',
                                                zIndex: 1,
                                                transition: 'color 0.3s ease',
                                            }}>
                                                {report.label}
                                            </Box>
                                        </Box>
                                    ))}
                                </Box>
                            </Box>
                        </Box>

                        {/* TDS Module */}
                        <Box sx={{
                            flex: 1,
                            background: 'linear-gradient(to bottom, #e3f2fd 0%, #f0f4ff 100%)',
                            borderRadius: '16px',
                            overflow: 'hidden',
                            border: '3px solid #03406d',
                            boxShadow: '0 4px 20px rgba(3, 64, 109, 0.15)'
                        }}>
                            <Box sx={{
                                background: '#03406d',
                                p: 2,
                                mb: 2
                            }}>
                                <Box sx={{
                                    fontSize: '28px',
                                    fontWeight: 700,
                                    color: '#ffffff',
                                    textAlign: 'center',
                                    letterSpacing: '1px'
                                }}>
                                    TDS MODULE
                                </Box>
                            </Box>
                            <Box sx={{ p: 4, pt: 0 }}>
                                <Box sx={{
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(2, 1fr)',
                                    gap: 2.5
                                }}>
                                    {tdsFilingOptions.map((report, index) => (
                                        <Box
                                            key={index}
                                            onClick={() => handleCardClick(report)}
                                            sx={{
                                                background: '#ffffff',
                                                borderRadius: '12px',
                                                p: 3,
                                                cursor: 'pointer',
                                                transition: 'all 0.2s ease',
                                                boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                                                minHeight: '80px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                borderLeft: '5px solid #03406d',
                                                position: 'relative',
                                                overflow: 'hidden',
                                                '&::before': {
                                                    content: '""',
                                                    position: 'absolute',
                                                    left: 0,
                                                    top: 0,
                                                    height: '100%',
                                                    width: '5px',
                                                    background: '#03406d',
                                                    transition: 'width 0.4s ease',
                                                    zIndex: 0
                                                },
                                                '&:hover': {
                                                    transform: 'translateY(-4px)',
                                                    boxShadow: '0 4px 16px rgba(3, 64, 109, 0.25)',
                                                    '& > div': {
                                                        color: '#ffffff'
                                                    }
                                                },
                                                '&:hover::before': {
                                                    width: '100%'
                                                }
                                            }}
                                        >
                                            <Box sx={{
                                                fontSize: '16px',
                                                fontWeight: 600,
                                                color: '#212121',
                                                textAlign: 'center',
                                                position: 'relative',
                                                zIndex: 1,
                                                transition: 'color 0.3s ease',
                                            }}>
                                                {report.label}
                                            </Box>
                                        </Box>
                                    ))}
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                ) : gstFilingOptions.length > 0 ? (
                    <Box sx={{ p: 4, display: 'flex', justifyContent: 'center' }}>
                        <Box sx={{
                            maxWidth: '900px',
                            width: '100%',
                            background: 'linear-gradient(to bottom, #e3f2fd 0%, #f0f4ff 100%)',
                            borderRadius: '16px',
                            overflow: 'hidden',
                            border: '3px solid #03406d',
                            boxShadow: '0 4px 20px rgba(3, 64, 109, 0.15)'
                        }}>
                            <Box sx={{
                                background: '#03406d',
                                p: 2,
                                mb: 2
                            }}>
                                <Box sx={{
                                    fontSize: '28px',
                                    fontWeight: 700,
                                    color: '#ffffff',
                                    textAlign: 'center',
                                    letterSpacing: '1px'
                                }}>
                                    GST MODULE
                                </Box>
                            </Box>
                            <Box sx={{ p: 4, pt: 0 }}>
                                <Box sx={{
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(3, 1fr)',
                                    gap: 2.5
                                }}>
                                    {gstFilingOptions.map((report, index) => (
                                        <Box
                                            key={index}
                                            onClick={() => handleCardClick(report)}
                                            sx={{
                                                background: '#ffffff',
                                                borderRadius: '12px',
                                                p: 3,
                                                cursor: 'pointer',
                                                transition: 'all 0.2s ease',
                                                boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                                                minHeight: '80px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                borderLeft: '5px solid #03406d',
                                                position: 'relative',
                                                overflow: 'hidden',
                                                '&::before': {
                                                    content: '""',
                                                    position: 'absolute',
                                                    left: 0,
                                                    top: 0,
                                                    height: '100%',
                                                    width: '5px',
                                                    background: '#03406d',
                                                    transition: 'width 0.4s ease',
                                                    zIndex: 0
                                                },
                                                '&:hover': {
                                                    transform: 'translateY(-4px)',
                                                    boxShadow: '0 4px 16px rgba(3, 64, 109, 0.25)',
                                                    '& > div': {
                                                        color: '#ffffff'
                                                    }
                                                },
                                                '&:hover::before': {
                                                    width: '100%'
                                                }
                                            }}
                                        >
                                            <Box sx={{
                                                fontSize: '16px',
                                                fontWeight: 600,
                                                color: '#212121',
                                                textAlign: 'center',
                                                position: 'relative',
                                                zIndex: 1,
                                                transition: 'color 0.3s ease',
                                            }}>
                                                {report.label}
                                            </Box>
                                        </Box>
                                    ))}
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                ) : tdsFilingOptions.length > 0 ? (
                    <Box sx={{ p: 4, display: 'flex', justifyContent: 'center' }}>
                        <Box sx={{
                            maxWidth: '900px',
                            width: '100%',
                            background: 'linear-gradient(to bottom, #e3f2fd 0%, #f0f4ff 100%)',
                            borderRadius: '16px',
                            overflow: 'hidden',
                            border: '3px solid #03406d',
                            boxShadow: '0 4px 20px rgba(3, 64, 109, 0.15)'
                        }}>
                            <Box sx={{
                                background: '#03406d',
                                p: 2,
                                mb: 2
                            }}>
                                <Box sx={{
                                    fontSize: '28px',
                                    fontWeight: 700,
                                    color: '#ffffff',
                                    textAlign: 'center',
                                    letterSpacing: '1px'
                                }}>
                                    TDS MODULE
                                </Box>
                            </Box>
                            <Box sx={{ p: 4, pt: 0 }}>
                                <Box sx={{
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(3, 1fr)',
                                    gap: 2.5
                                }}>
                                    {tdsFilingOptions.map((report, index) => (
                                        <Box
                                            key={index}
                                            onClick={() => handleCardClick(report)}
                                            sx={{
                                                background: '#ffffff',
                                                borderRadius: '12px',
                                                p: 3,
                                                cursor: 'pointer',
                                                transition: 'all 0.2s ease',
                                                boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                                                minHeight: '80px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                borderLeft: '5px solid #03406d',
                                                position: 'relative',
                                                overflow: 'hidden',
                                                '&::before': {
                                                    content: '""',
                                                    position: 'absolute',
                                                    left: 0,
                                                    top: 0,
                                                    height: '100%',
                                                    width: '5px',
                                                    background: '#03406d',
                                                    transition: 'width 0.4s ease',
                                                    zIndex: 0
                                                },
                                                '&:hover': {
                                                    transform: 'translateY(-4px)',
                                                    boxShadow: '0 4px 16px rgba(3, 64, 109, 0.25)',
                                                    '& > div': {
                                                        color: '#ffffff'
                                                    }
                                                },
                                                '&:hover::before': {
                                                    width: '100%'
                                                }
                                            }}
                                        >
                                            <Box sx={{
                                                fontSize: '16px',
                                                fontWeight: 600,
                                                color: '#212121',
                                                textAlign: 'center',
                                                position: 'relative',
                                                zIndex: 1,
                                                transition: 'color 0.3s ease',
                                            }}>
                                                {report.label}
                                            </Box>
                                        </Box>
                                    ))}
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                ) : (
                    <Box sx={{
                        textAlign: 'center',
                        mt: 10,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}>
                        <InfoOutlinedIcon sx={{ fontSize: 64, color: '#90a4ae', mb: 2 }} />
                        <Box sx={{ fontSize: '18px', color: '#607d8b' }}>
                            Please activate the Filing Services to access.
                        </Box>
                    </Box>
                )}
                </>
            )}
        </Box>
    );
}